import { metaObject } from '@/config/site.config';
import LogisticsDashboard from '../shared/orders/dashboard';

export const metadata = {
  ...metaObject(),
};

export default function   FileDashboardPage() {
  return <LogisticsDashboard />;
}
